import store from "../store";
import { ERROR_INITIAL, ERROR_UPDATE, FLAG_REPORT_INITIAL, FLAG_REPORT_UPDATE } from "../store/slices";
import { DatabaseInstance } from "./databaseClass";

class FlagReportClass {
  private store: any;
  private dispatch: any;
  constructor() {
    this.store = store;
    this.dispatch = store.dispatch;
  }

  // get all app reports
  public getAllReports = async () => {
    console.log("getAllReports");
    store.dispatch(
      FLAG_REPORT_UPDATE({
        data: {
          ...FLAG_REPORT_INITIAL,
          isLoading: true,
        },
      }),
    );

    const data = {
      endpoint: "admin/get-app-flags",
    };

    try {
      const res = await DatabaseInstance.getRecord(data);

      console.log("flags/reports", res);

      store.dispatch(
        FLAG_REPORT_UPDATE({
          data: {
            ...FLAG_REPORT_INITIAL,
            reports: res,
            isLoading: false,
          },
        }),
      );
      return res;
    } catch (error) {
      store.dispatch(
        ERROR_UPDATE({
          data: {
            ...ERROR_INITIAL,
            error: error,
          },
        }),
      );
    }
  };

  public getFlaggedItem = async (id: string) => {
    store.dispatch(
      FLAG_REPORT_UPDATE({
        data: {
          ...this.store.getState().flagReport,
          isLoading: true,
        },
      }),
    );

    const data = {
      endpoint: `admin/get-flagged-item/${id}`,
    };

    try {
      const res = await DatabaseInstance.getRecord(data);

      store.dispatch(
        FLAG_REPORT_UPDATE({
          data: {
            ...this.store.getState().flagReport,
            isLoading: false,
          },
        }),
      );
      return res;
    } catch (error) {
      store.dispatch(
        ERROR_UPDATE({
          data: {
            ...ERROR_INITIAL,
            error: error,
          },
        }),
      );
    }
  };

  // resolve a flag
  public resolveFlag = async (id: string) => {
    store.dispatch(
      FLAG_REPORT_UPDATE({
        data: {
          ...this.store.getState().flagReport,
          isLoading: true,
        },
      }),
    );

    const data = {
      endpoint: `admin/resolve-content-flag/${id}`,
    };

    try {
      const res = await DatabaseInstance.updateRecord(data);

      store.dispatch(
        FLAG_REPORT_UPDATE({
          data: {
            ...this.store.getState().flagReport,
            isLoading: false,
          },
        }),
      );
      return res;
    } catch (error) {
      store.dispatch(
        ERROR_UPDATE({
          data: {
            ...ERROR_INITIAL,
            error: error,
          },
        }),
      );
    }
  };
}

const FlagReportInstance = new FlagReportClass();

export { FlagReportInstance };
